import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { EpoProcessing } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/epo-processing/epo-processing';
import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const InstantOfferLoading = ({ isStepActive = false, isMobile = false }) =>
  isStepActive
    ? React.createElement(EpoProcessing, {
        className: 'pb-1',
        isSubmittingFinished: false,
        isMobile,
        setLoadingStatus: noop,
      })
    : null;

InstantOfferLoading.propTypes = {
  isStepActive: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default {
  InstantOfferStep: lazyLoad({
    loader: () =>
      import(
        /* webpackChunkName: "instant-offer-step" */ 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/instant-offer-step/instant-offer-step'
      ),
    componentName: 'InstantOfferStep',
    loading: InstantOfferLoading,
  }),
};
